import React from "react";
import startCase from "lodash/startCase";
import { LOGO_DIMENSIONS } from "utils/constants/image";
import Image from "components/Image";
import {
  INTEGRATION_MODEL_ADMIN_URL,
  INTEGRATION_MODEL_UID
} from "utils/constants/metadata";
import ExternalLink from "components/ExternalLink";

const ConnectionDetails = ({ service, details }) => {
  return (
    <div className="flex flex-column flex-row-ns justify-between ba bn-ns hairline-1 pa3 pa0-ns">
      <div className="flex-shrink-0 flex flex-row items-center">
        <Image
          src={`/assets/integrations/${service}/logo.png`}
          {...LOGO_DIMENSIONS[service]}
          alt={service}
        ></Image>
        <div className="f6 fw5 pl3">{details[INTEGRATION_MODEL_UID]}</div>
      </div>
      <div className="flex items-center pt2 pt0-ns">
        <ExternalLink
          href={details[INTEGRATION_MODEL_ADMIN_URL]}
          copy={`Manage on ${startCase(service)}`}
          customClasses={{
            container: "w-100",
            link:
              "link flex flex-row items-center justify-between link__decoration--hover color-primary pointer w-100 word-break-all",
            copy: "f6 lh-title pr2"
          }}
        />
      </div>
    </div>
  );
};

export default ConnectionDetails;
